import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from '../brand/Logo';
import { navItems } from '../../data/site';
import { useBrand } from '../../contexts/BrandContext';
export function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const {
    brand
  } = useBrand();
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  return <header className="sticky top-0 z-50 bg-cream/95 backdrop-blur" data-id="element-175" data-mp="i0ssn4fdd7zr">
      <div className="hidden border-b border-ink/10 bg-cream-deep text-ink-soft md:block" data-id="element-176" data-mp="vqwalj77ufje">
        <div className="mx-auto flex max-w-shell items-center justify-between px-8 py-2 text-[0.6875rem] uppercase tracking-label" data-id="element-177" data-mp="qznxac2rma0y">
          <p data-id="element-178" data-mp="38qxfxo8v362">{brand.copy.utilityLeft}</p>
          <p className="text-brick" data-id="element-179" data-mp="3ugml8x9buikp">{brand.copy.utilityRight}</p>
        </div>
      </div>

      <div className="mx-auto max-w-shell px-6 md:px-8" data-id="element-180" data-mp="3ues8i687lwrp">
        <div className="flex items-center justify-between py-5" data-id="element-181" data-mp="6uvppki5flyc">
          <Link to="/" className="text-ink" aria-label={`${brand.name} home`} data-id="element-182" data-mp="bu89fwdq4cwp">
            <Logo className="text-base md:text-lg" data-id="element-183" data-mp="glhxisjmj86h" />
          </Link>

          <nav aria-label="Primary" className="hidden items-center gap-7 lg:flex" data-id="element-184" data-mp="gm9t43d815wr">
            {navItems.map(item => <NavLink key={item.to} to={item.to} className={({
            isActive
          }) => `text-sm transition-colors duration-150 ease-republic ${isActive ? 'text-brick' : 'text-ink-soft hover:text-ink'}`} data-id="element-185" data-mp="3k26vhq5559kj">
                {item.label}
              </NavLink>)}
          </nav>

          <div className="hidden items-center gap-6 lg:flex" data-id="element-186" data-mp="19afdgp0d4sw2">
            <Link to="/pricing" className="text-sm text-ink-soft transition-colors duration-150 ease-republic hover:text-ink" data-id="element-187" data-mp="19c8e9noaoiw5">
              Sign in
            </Link>
            <Link to="/get-started" className="rounded-brand bg-brick px-6 py-3 text-sm font-medium text-cream transition-colors duration-150 ease-republic hover:bg-brick-deep" data-id="element-188" data-mp="3ae7vwqbpbq0b">
              Start intake
            </Link>
          </div>

          <button type="button" onClick={() => setOpen(value => !value)} className="text-ink lg:hidden" aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} data-id="element-189" data-mp="3eerqpn8syhja">
            {open ? <XIcon className="h-6 w-6" data-id="element-190" data-mp="30eh10nj8b8zp" /> : <MenuIcon className="h-6 w-6" data-id="element-191" data-mp="30fs4em8rieqa" />}
          </button>
        </div>
        <div className="rule" data-id="element-192" data-mp="2vmfsncp6m2ey" />
      </div>

      <AnimatePresence data-id="element-193" data-mp="2vle6ac2ptthx">
        {open && <motion.div initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden border-b border-ink/10 bg-cream lg:hidden" data-id="element-194" data-mp="27x4odl8mhpw2">
            <nav aria-label="Mobile" className="mx-auto max-w-shell px-6 py-6" data-id="element-195" data-mp="n8iz7lg0x2e0">
              <ul className="flex flex-col" data-id="element-196" data-mp="9gmalrdkdamd">
                {navItems.map(item => <li key={item.to} className="border-b border-ink/10" data-id="element-197" data-mp="eenvmhujvk0h">
                    <Link to={item.to} className="block py-4 font-serif text-2xl text-ink" data-id="element-198" data-mp="ect7kunzfbs6">
                      {item.label}
                    </Link>
                  </li>)}
              </ul>
              <Link to="/get-started" className="mt-6 inline-flex rounded-brand bg-brick px-6 py-3 text-sm font-medium text-cream" data-id="element-199" data-mp="s6kjuat3l9rl">
                Start intake
              </Link>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}